import { styled } from '@mui/material';
import { ReactNode } from 'react';
import { Spacing } from '../../design-system/spacing';
import { CovalyntLogoLarge } from '../Icons/CovalyntLogoLarge';
import { CovalyntLogoSmall } from '../Icons/CovalyntLogoSmall';
import {
  LogoWrapper,
  RightToolbarContainer,
  TopNavbarToolbar,
  TopNavbarWrapper,
} from './TopNavbar.styles';

export interface TopNavBarProps {
  readonly logoVariant: 'none' | 'small' | 'large';
  readonly leftToolbar?: ReactNode;
  readonly rightToolbar?: ReactNode;
  readonly thin?: boolean;
}

const shouldForwardProp = (prop: string) => prop !== 'leftToolbar';

const StyledCovalyntLogoLarge = styled(CovalyntLogoLarge, {
  shouldForwardProp,
})<{
  leftToolbar?: boolean;
}>((props) => ({
  marginLeft: props.leftToolbar ? props.theme.spacing(Spacing.Small) : 0,
}));

const StyledCovalyntLogoSmall = styled(CovalyntLogoSmall, {
  shouldForwardProp,
})<{
  leftToolbar?: boolean;
}>((props) => ({
  marginLeft: props.leftToolbar ? props.theme.spacing(Spacing.Small) : 0,
}));

export function TopNavbar({
  logoVariant = 'none',
  leftToolbar = null,
  rightToolbar = null,
  thin = true,
  ...rest
}: TopNavBarProps) {
  return (
    <TopNavbarWrapper {...rest}>
      <TopNavbarToolbar thin={thin}>
        <RightToolbarContainer>
          {leftToolbar}
          {logoVariant !== 'none' && (
            <LogoWrapper>
              {logoVariant === 'small' ? (
                <StyledCovalyntLogoSmall
                  aria-label="Covalynt Logo"
                  leftToolbar={Boolean(leftToolbar)}
                />
              ) : (
                <StyledCovalyntLogoLarge
                  aria-label="Covalynt Logo"
                  leftToolbar={Boolean(leftToolbar)}
                />
              )}
            </LogoWrapper>
          )}
        </RightToolbarContainer>
        {rightToolbar}
      </TopNavbarToolbar>
    </TopNavbarWrapper>
  );
}
